import { render, staticRenderFns } from "./integracao.vue?vue&type=template&id=6282a57a&scoped=true"
import script from "./integracao.vue?vue&type=script&lang=js"
export * from "./integracao.vue?vue&type=script&lang=js"
import style0 from "./integracao.vue?vue&type=style&index=0&id=6282a57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282a57a",
  null
  
)

export default component.exports